var _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHowWorksBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 529,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#387",
    fillOpacity: 0.1,
    d: "M1228 3h41v41h-41z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 683,
    cy: 330,
    r: 19.5,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1315,
    cy: 489,
    r: 10.5,
    stroke: "#387",
    strokeOpacity: 0.07,
    strokeWidth: 7
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI1MjkiIHZpZXdCb3g9IjAgMCAxNDQwIDUyOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMTIyOCIgeT0iMyIgd2lkdGg9IjQxIiBoZWlnaHQ9IjQxIiBmaWxsPSIjMzM4ODc3IiBmaWxsLW9wYWNpdHk9IjAuMSIvPgo8Y2lyY2xlIGN4PSI2ODMiIGN5PSIzMzAiIHI9IjE5LjUiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLW9wYWNpdHk9IjAuMDciIHN0cm9rZS13aWR0aD0iNyIvPgo8Y2lyY2xlIGN4PSIxMzE1IiBjeT0iNDg5IiByPSIxMC41IiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS1vcGFjaXR5PSIwLjA3IiBzdHJva2Utd2lkdGg9IjciLz4KPC9zdmc+Cg==";
export { SvgHowWorksBg as ReactComponent };